<div class="col-sm-12 no-padding">

  <h3>
    Informações do repasse

    <a class="btn btn-default  btn-sm pull-right" (click)="goBack()">
      <i class="fa fa-reply"></i>&nbsp;Voltar para listagem</a>
  </h3>

  <div class="col-sm-12">
    <h4>
      Repasse tipo: <b>{{ this.repasse.tipo}}</b> -
      Data: <b>{{ this.repasse.obDataTransf | date:'dd/MM/yyyy' }}</b> -
      Valor: <b>R$ {{ this.repasse.obValorReceb | number:'.2' }}</b>
    </h4>

    <br>
    <br>

    <div class="col-sm-12 no-padding">
      <h3 class="text-light-blue">
        <b>Análises do repasse</b>
      </h3>
      <hr>
      <div class="col-sm-12">

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Relatório de visita In loco</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioVisitaInLoco = !relatorioVisitaInLoco; closeOthers(0)"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body">
            <analise-repasse-relatorio [tipoRelatorioInput]="'relatorio_visita_in_loco'" *ngIf="relatorioVisitaInLoco"></analise-repasse-relatorio>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Parecer técnico da prestação de contas</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
              (click)="parecerTecnicoPrestacaoContas = !parecerTecnicoPrestacaoContas; closeOthers(1)"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <analise-repasse-relatorio [tipoRelatorioInput]="'parecer_tecnico_prestacao_contas'" *ngIf="parecerTecnicoPrestacaoContas"></analise-repasse-relatorio>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Relatório técnico de monitoramento e avaliação</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
              (click)="relatorioTecnicoMonitoramentoAvaliacao = !relatorioTecnicoMonitoramentoAvaliacao; closeOthers(2)"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <analise-repasse-relatorio [tipoRelatorioInput]="'relatorio_tecnico_monitoramento_avaliacao'" *ngIf="relatorioTecnicoMonitoramentoAvaliacao"></analise-repasse-relatorio>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Análise financeira</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
              (click)="analiseFinanceira = !analiseFinanceira; closeOthers(3)"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <analise-repasse-relatorio [tipoRelatorioInput]="'analise_financeira'" *ngIf="analiseFinanceira"></analise-repasse-relatorio>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Outras pendências</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
              (click)="outrasPendencias = !outrasPendencias; closeOthers(4)"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <analise-repasse-relatorio [tipoRelatorioInput]="'outras_pendencias'" *ngIf="outrasPendencias"></analise-repasse-relatorio>
          </div>
        </div>

      </div>
    </div>

    <div class="col-sm-12 no-padding">
      <h3 class="text-light-blue">
        <b>Relatórios do repasse</b>
      </h3>
      <hr>

      <div class="col-sm-12">
        <p>Selecione o período para filtrar nos relatórios:</p>

        <div class="form-group col-sm-3">
          <label>De</label>
          <input type="date" class="form-control" [(ngModel)]="periodoInicial">
        </div>
        <div class="form-group col-sm-3">
          <label>Até</label>
          <input type="date" class="form-control" [(ngModel)]="periodoFinal">
        </div>
      </div>

      <div class="col-sm-12">
        <hr><br>
      </div>

      <div class="col-sm-12">

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Prestação de contas</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioPrestacaoContas = !relatorioPrestacaoContas"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <prestacao-contas [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioPrestacaoContas"></prestacao-contas>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Execução financeira</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <div class="col-sm-12">Módulo ainda não disponível</div>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Receita e despesa</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioReceitaDespesa = !relatorioReceitaDespesa"><i class="fa fa-plus"></i></button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <receita-despesa [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioReceitaDespesa"></receita-despesa>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Pagamentos efetuados</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioPagamentosEfetuados = !relatorioPagamentosEfetuados"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <relacao-pagamento [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioPagamentosEfetuados"></relacao-pagamento>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Notas e comprovantes fiscais</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioNotasComprovantes = !relatorioNotasComprovantes"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <notas-comprovantes [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioNotasComprovantes"></notas-comprovantes>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Ordem bancária e comprovante de transferência</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioOrdemBancariaComprovanteTransferencia = !relatorioOrdemBancariaComprovanteTransferencia"><i
                  class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <ordem-bancaria-comprovante-transferencia [periodoInicialInput]="periodoInicial"
              [periodoFinalInput]="periodoFinal" *ngIf="relatorioOrdemBancariaComprovanteTransferencia">
            </ordem-bancaria-comprovante-transferencia>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Extrato da conta bancária</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioExtratoBancario = !relatorioExtratoBancario"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <extrato-bancario [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioExtratoBancario"></extrato-bancario>
          </div>
        </div>

        <div class="box box-solid box-default collapsed-box">
          <div class="box-header with-border">
            <h3 class="box-title">Cópia das cotações de preços realizadas</h3>
            <div class="box-tools pull-right">
              <button type="button" class="btn btWn-box-tool" data-widget="collapse"
                (click)="relatorioCotacaoPreco = !relatorioCotacaoPreco"><i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="box-body" style="display: none;">
            <cotacao-preco [periodoInicialInput]="periodoInicial" [periodoFinalInput]="periodoFinal"
              *ngIf="relatorioCotacaoPreco"></cotacao-preco>
          </div>
        </div>

        <br>

      </div>

    </div>



  </div>